<ng-content></ng-content>
<joi-input #manageTitle class="big-title" [italicPlaceholder]="true"  [type]="'textarea'" [disabled]="readOnly" [(model)]="setup.name" [placeholder]="'Setup name'" (joiChange)="saveSetup()"></joi-input>

<div class="toggle-section">
  <grey-wrapper class="numbers">
    <h5>Expected numbers</h5>
    <joi-input [italicPlaceholder]="true" [fixedWidth]="true" [disabled]="readOnly" [(model)]="setup.expected" 
      placeholder="Expected numbers..." (joiChange)="saveSetup()"></joi-input>
  </grey-wrapper>
  <grey-wrapper class="half-column setup">
    <h5>Setup</h5>
    <joi-input [italicPlaceholder]="true" type="textarea" [disabled]="readOnly" [(model)]="setup.setup" 
      placeholder="Theatre, banquet, etc..." (joiChange)="saveSetup()"></joi-input>
  </grey-wrapper>
  <grey-wrapper class="numbers">
    <h5>Capacity</h5>
    <joi-input [italicPlaceholder]="true" [fixedWidth]="true" [disabled]="readOnly" [(model)]="setup.capacity" 
      placeholder="Capacity..." (joiChange)="saveSetup()"></joi-input>
  </grey-wrapper>
</div>

<div class="toggle-section">
  <grey-wrapper class="half-column">
    <setup-time [program]="program" [dayProp]="'accessDay'" [timeProp]="'access'" [readOnly]="readOnly" [setup]="setup" (onSave)="saveSetup()"></setup-time>
  </grey-wrapper>
  <grey-wrapper class="half-column">
    <setup-time [program]="program" [dayProp]="'clearDay'"  [timeProp]="'clear'"  [readOnly]="readOnly" [setup]="setup" (onSave)="saveSetup()" [title]="'Cleared time'"></setup-time>
  </grey-wrapper>
</div>


<div class="toggle-section full">
  <grey-wrapper style="margin-top: 10px;">
    <h5>Applies to these sessions:</h5>
    <on-sessions-view 
      [readOnly]="readOnly"
      [tags]="setup.sessionIds | idsToTagData:sessionMap"
      (remove)="removeSessionId($event)"
      (open)="editSessionIds($event)"
    ></on-sessions-view>
  </grey-wrapper>
</div>

<title-icon [title]="'Setup notes'" [titleIcon]="'event_information18'"></title-icon>
<editable-notes
  [initClosed]="true"
  [noPadding]="true"
  [readOnly]="readOnly"
  [notes]="[{ id: 'setupNotes' + setup.id, title: 'Setup notes', items: setup.notes, placeholder: 'No setup notes'}]"
  [noItemsMessage]="'No setup notes'"
  (onChanges)="saveSetup()"
></editable-notes>

<assets
  [assetIds]="setup.assetIds || []" 
  [entityHolderName]="'setup'"
  [title]="'Setup Assets'"
  [readOnly]="readOnly"
  (idsAdded)="saveAssetIds($event)"
  (idRemoved)="removeAssetId($event)"
></assets>